import type { CSATMode, CsatChannels, CsatTemplate } from 'src/pages/csat/slice/csatTypes';

import { createSlice } from '@reduxjs/toolkit';

export interface TenantAISettings {
  agentAssistEnabled: boolean;
  chatbotEnabled: boolean;
  voicebotEnabled: boolean;
  sentimentEnabled: boolean;
  analyticsEnabled: boolean;
  kbEnabled?: boolean;
  csatEnabled?: boolean;
  csatMode?: CSATMode;
  csatChannels?: CsatChannels | null;
  csatTemplate?: CsatTemplate | null;
  ivrGeneratorEnabled?: boolean;
  llmProvider?: string;
  allowedModels?: string[];
  ttsProvider?: string;
  sttProvider?: string;
  maxTokensPerDay?: number;
  todayTokensUsed?: number;
  // Voicebot-specific
  voicebotLLMProvider?: string;
  voicebotModel?: string;
  voicebotMaxTokens?: number;
  voicebotTemperature?: number;
  voicebotSystemPrompt?: string;
  voicebotCustomEndpoint?: string;
}

interface AISettingsState {
  settings: TenantAISettings;
  loaded: boolean;
}

const initialState: AISettingsState = {
  settings: {
    agentAssistEnabled: false,
    chatbotEnabled: false,
    voicebotEnabled: false,
    sentimentEnabled: false,
    analyticsEnabled: false,
    kbEnabled: false,
    csatEnabled: false,
    ivrGeneratorEnabled: false,
  },
  loaded: false,
};

const aiSettingsSlice = createSlice({
  name: 'aiSettings',
  initialState,
  reducers: {
    setAISettings(state, action: { payload: TenantAISettings }) {
      state.settings = {
        ...state.settings,
        ...action.payload,
      };
      state.loaded = true;
    },
    clearAISettings(state) {
      state.settings = initialState.settings;
      state.loaded = false;
    },
  },
});


export const { setAISettings, clearAISettings } = aiSettingsSlice.actions;
export default aiSettingsSlice.reducer;
